<template>

    <div id="cost-index">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Cost Indexes</h1>
            </div>

            <div class="flex mb-4 justify-end">
                <router-link :to="{ name: 'accounts' }" custom v-slot="{ navigate }">
                    <button @click="navigate" class="btn-outline justify-center px-4 ml-4">
                        Go Back
                    </button>
                </router-link>
                <router-link :to="{ name: 'cost-indexes.create' }" custom v-slot="{ navigate }">
                    <button @click="navigate" class="btn justify-center px-4 ml-4">
                        Create Cost Index
                    </button>
                </router-link>
            </div>
        </div>

        <div class="flex flex-col"  v-if="loaded">

            <div class="index-table" v-if="form.indexDataAvailable()">
                <div>
                    <div>
                        <table>
                            <thead>
                            <tr>
                                <th scope="col" class="text-left tracking-wider">
                                    &nbsp;
                                </th>
                                <th scope="col" class="text-left tracking-wider">
                                    Cost Index Identifier
                                </th>
                                <th scope="col" class="text-center tracking-wider">
                                    Discount Adjustment
                                </th>
                                <th scope="col" class="text-center tracking-wider">
                                    Transaction Fee
                                </th>
                                <th scope="col" class="relative p-3">
                                    <span class="sr-only">Cost Index Delete</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="colored-row" v-for="(cost_index, index) in form.index_data.data">
                                <td>&nbsp;</td>
                                <td>
                                    <span class="font-medium">{{ cost_index.id }}</span><br>
                                    <span class="text-gray-400">{{ formatDateShort(cost_index.created_at) }}</span>
                                </td>
                                <td class="text-center">
                                    {{ cost_index.discount_adjustment / 100 }}%
                                </td>
                                <td class="text-center">
                                    {{ cost_index.transaction_fee / 100 }}
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr class="py-6 text-xs font-medium">
                                <td colspan="6" class="text-center">
                                    <infinite-loading @infinite="infiniteHandler">
                                        <div slot="spinner">Loading...</div>
                                        <div slot="no-more">No more Cost Indexes</div>
                                    </infinite-loading>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Cost Indexes Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any cost indexes.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Cost Indexes" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {CostIndex} from "../../app/Payment/CostIndex";
import InfiniteLoading from "vue-infinite-loading";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "CostIndex",
    mixins: [PermissionMixin, FormattingMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading,
        InfiniteLoading
    },
    methods: {
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.index(true).then(response => {
                    $state.loaded();
                });
            } else {
                $state.loaded();
                $state.complete();
            }
        },
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new CostIndex();

            vm.form.index().then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


